import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import ReusableCard from '../../components/cards/ReusableCard';
import { PrimaryButton } from '../../components/common/Buttons';
import LoadingComponent from '../../components/common/LoadingComponent';
import { BodyContainer } from '../../components/hospitalization/body';
import {
  HeaderContainer,
  HeaderText,
  HeaderTitleContainer,
  OuterContainer,
} from '../../components/hospitalization/header';
import { FadeInTransition } from '../../components/transitions/transitions';
import {
  fetchInconvenientRequest,
  submitInconvenientRequest,
} from '../../services';
import infoIcon from '../../images/info-icon.svg';
import { showError } from '../../utils';
import ellipseImage from '../../images/common/empty-ellipse.svg';
import tickImage from '../../images/common/done-tick.svg';
import chipsImage from '../../images/common/chips.svg';

const OptionBlock = styled.div`
  background: #f0f3f6b2;
  color: #585969;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;
  margin-bottom: 7.5px;
  border: ${(props) =>
    props.selected ? '1px solid #ffbb00' : '1px solid transparent'};
`;

const RaiseInconvenience = ({ authToken }) => {
  const { requestId } = useParams();

  const [requestDetails, setRequestDetails] = useState({});
  const [possibleReasons, setPossibleReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isErrored, setIsErrored] = useState(false);

  useEffect(() => {
    setLoading(true);

    const getRequests = async () => {
      try {
        const response = await fetchInconvenientRequest(requestId, authToken);
        setRequestDetails(response.data.requestDetails);
        setPossibleReasons(response.data.inconvenienceReasons);
        if (typeof response.data.canMarkInconvenient === 'boolean') {
          setIsSubmitted(!response.data.canMarkInconvenient);
        }
      } catch (err) {
        showError(err);
        setIsErrored(true);
      }
      setLoading(false);
    };

    getRequests();
  }, [requestId, authToken]);

  const submitInconvenience = async () => {
    setLoading(true);
    try {
      await submitInconvenientRequest(requestId, selectedReason, authToken);
      setIsSubmitted(true);
    } catch (err) {
      showError(err);
    }
    setLoading(false);
  };

  return (
    <FadeInTransition in timeout={200} mountOnEnter appear unmountOnExit>
      <OuterContainer>
        <HeaderContainer>
          <HeaderTitleContainer>
            <HeaderText>Raise Inconvenience</HeaderText>
          </HeaderTitleContainer>
        </HeaderContainer>

        <BodyContainer className="p-2 px-4" style={{ position: 'relative' }}>
          {loading ? (
            <div style={{ height: '100vh', background: '#ffffff' }}>
              <LoadingComponent />
            </div>
          ) : isErrored ? (
            <></>
          ) : (
            <>
              {isSubmitted ? (
                <Confirmation />
              ) : (
                <>
                  <div className="mb-8">
                    <ReusableCard
                      requestDetails={requestDetails}
                      tagName="Clinic Appointment"
                    />
                  </div>

                  <div className="text-body-l font-semibold text-txtlight mb-8 mt-12">
                    Confirmed consultation not convenient for you? Let us know
                    why:
                  </div>

                  <div>
                    {possibleReasons.map((item) => (
                      <OptionBlock
                        selected={selectedReason === item}
                        key={item}
                        onClick={() => setSelectedReason(item)}
                      >
                        {item}
                      </OptionBlock>
                    ))}
                  </div>

                  <PrimaryButton
                    className="w-full mt-10"
                    onTap={submitInconvenience}
                    disabled={!selectedReason || loading}
                  >
                    <div className="text-body-l font-bold text-center py-4px">
                      Submit
                    </div>
                  </PrimaryButton>
                </>
              )}
            </>
          )}
        </BodyContainer>
      </OuterContainer>
    </FadeInTransition>
  );
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  user: state.user,
});

export default connect(mapStateToProps)(RaiseInconvenience);

const Confirmation = () => (
  <div className="my-auto d-flex flex-column ">
    <div style={{ height: '200px', position: 'relative' }}>
      <img
        alt="Confirm"
        src={chipsImage}
        style={{
          position: 'absolute',
          height: '100%',
          left: '50%',
          top: '0',
          transform: 'translateX(-50%)',
        }}
      />
      <img
        alt="Confirm"
        src={ellipseImage}
        style={{
          position: 'absolute',
          height: '100px',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
      <img
        alt="Confirm"
        src={tickImage}
        style={{
          position: 'absolute',
          height: '100px',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
    <div className="mt-10 text-center px-12 pt-10" style={{ fontWeight: 700 }}>
      Thank you for your time!
    </div>
    <div
      className="mt-8 text-center px-12"
      style={{ color: '#767787', fontSize: '13px' }}
    >
      Our customer support team will be calling you shortly regarding your
      appointment.
    </div>
    <div
      style={{
        background: '#CFC8FF',
        position: 'absolute',
        transform: 'translateX(-50%)',
        bottom: '7.5%',
        left: '50%',
        width: '80%',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'row',
        padding: '10px',
      }}
    >
      <img className="mr-4" alt="Info" src={infoIcon} />
      <div style={{ fontSize: '10px', fontWeight: '500' }}>
        Your appointment's status has been updated to <strong>pending</strong>.
        You can either confirm or cancel the appointment.
      </div>
    </div>
  </div>
);
